import React, { useContext, useEffect, useState } from "react";

import orderBy from "lodash.orderby";
import { observer } from "mobx-react";

import ComponentContext from "../../../contexts/ComponentContext";
import apiInstance from "../../../services/api";
import Loader from "../Loader/Loader";
import Venue from "../Venue/Venue";

function Venues() {
  const [venues, setVenues] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const {
    venueIdentifierFilter = "",
    placeCount,
    placeholder,
    title,
  } = useContext(ComponentContext);

  useEffect(() => {
    apiInstance.getAllVenues().then((response) => {
      let availableVenues;

      if (
        typeof venueIdentifierFilter === "string" &&
        venueIdentifierFilter.length > 0
      ) {
        const accountIdsToRemove = venueIdentifierFilter
          .split(",")
          .map((item) => item.trim());

        availableVenues = response.data.filter((venue) => {
          return !accountIdsToRemove.includes(venue.id);
        });
      }

      setVenues(
        orderBy(availableVenues, ["totalVacancies"], "desc").slice(
          0,
          placeCount || 4
        )
      );
      setIsLoading(false);
    });
  }, []);

  return (
    <>
      <h2 className=" text-center mb-4">{title}</h2>
      {isLoading && <Loader />}

      {!isLoading && (
        <div className="row">
          {venues.map((venue) => (
            <div key={venue.id} className="col-6 col-lg-3 mb-5 text-center">
              <Venue placeholder={placeholder} venue={venue} />
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export default observer(Venues);
